var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _vm._l(_vm.requiredDocsList, function(attachment, outer) {
        return _c(
          "table",
          { key: outer },
          [
            _c("tr", [
              _c("td", { staticClass: "table-head", attrs: { colspan: "2" } }, [
                _vm._v(_vm._s(attachment.name) + "*")
              ])
            ]),
            _vm._v(" "),
            _vm._l(attachment.items, function(item, inner) {
              return _c("tr", { key: inner }, [
                _c("td", { staticClass: "table-number" }, [
                  _vm._v(_vm._s(item.index))
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "table-text" },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            name: "prilohaDetail",
                            params: { id: item.key }
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.requiredDocs[item.key].name))]
                    )
                  ],
                  1
                )
              ])
            })
          ],
          2
        )
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("table", [
      _c("tr", [
        _c("td", { staticClass: "table-label" }, [_vm._v("P.Č.")]),
        _vm._v(" "),
        _c("td", { staticClass: "table-label" }, [
          _vm._v("Názov dokladu prílohy")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }